export default "__VITE_ASSET__DHW1byon__"